/*eslint-disable*/
export const messages = {
  // Common UI elements
  "Cancel": "रद्द करें",
  "Change theme": "थीम बदलें",
  "Clear chat": "चैट साफ़ करें",
  "Clear chat history": "चैट इतिहास साफ़ करें",
  "Connecting...": "कनेक्ट हो रहा है...",
  "Continue": "जारी रखें",
  "Decrease font size": "फ़ॉन्ट आकार घटाएँ",
  "Disclaimer": "अस्वीकरण",
  "Enter your message...": "अपना संदेश दर्ज करें...",
  "Type your message...": "अपना संदेश दर्ज करें...",
  "Error": "त्रुटि",
  "Font size": "फ़ॉन्ट आकार",
  "Increase font size": "फ़ॉन्ट आकार बढ़ाएँ",
  "Language": "भाषा",
  "MJ Lab": "एमजे लैब",
  "Reset font size": "फ़ॉन्ट आकार रीसेट करें",
  "Respond time: {time}s": "प्रतिक्रिया समय: {time}s",
  "Response time:": "प्रतिक्रिया समय:",
  "Send": "भेजें",
  "Settings": "सेटिंग्स",
  "Support the project": "परियोजना का समर्थन करें",
  "System": "सिस्टम",
  "Theme": "थीम",
  "Thinking...": "विचार कर रहा है...",
  "Toggle theme": "थीम टॉगल करें",
  "You asked:": "आपने पूछा:",
  
  // Headers
  "Welcome to Leen by MJ": "MJ द्वारा Leen में आपका स्वागत है",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "नमस्ते, मैं {{name}} हूँ, MJ द्वारा बनाया गया एक AI सहायक।",
  "I am expert in labor laws and regulations for Saudi Arabia.": "मैं सऊदी अरब के श्रम कानूनों और नियमों की विशेषज्ञ हूँ।",
  "Ask me a question, and I will gladly answer you.": "मुझसे एक प्रश्न पूछें, और मैं खुशी से आपको उत्तर दूंगा।",
  "Do not share confidential data.": "गोपनीय डेटा साझा न करें।",
  "I am powered using": "मैं इसका उपयोग करके संचालित हूँ",
  "Labor Law Expert": "श्रम कानून विशेषज्ञ",
  "by MJ": "MJ द्वारा",
  "Leen": "Leen",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi labor laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**अस्वीकरण:** {{name}} एक प्रयोगात्मक AI सहायक है जो सऊदी अरब के श्रम कानूनों और नियमों से डेटा का उपयोग करके प्रतिक्रिया देने के लिए डिज़ाइन किया गया है, मान्यताओं या अशुद्धियों से बचते हुए। मैं इसके व्यवहार या इसकी प्रतिक्रियाओं की सटीकता के लिए जिम्मेदार नहीं हूँ।",
  
  // Frameworks - keeping these for backward compatibility
  "Automatic detection": "स्वचालित पहचान",
  "Labor Law": "श्रम कानून",
  "Saudization": "सौदीकरण",
  "Contracts": "अनुबंध",
  "Termination": "समाप्ति",
  "Wages & Benefits": "वेतन और लाभ",
  "Leave Policies": "अवकाश नीतियां",
  "Workplace Safety": "कार्यस्थल सुरक्षा",
  
  // Models
  "Claude by Anthropic": "Anthropic द्वारा Claude",
  "DeepSeek by Groq": "Groq द्वारा DeepSeek",
  "MJ Lab Mode": "MJ लैब मोड",
  
  // Error messages
  "An error occurred": "एक त्रुटि हुई",
  "Failed to change language": "भाषा बदलने में विफल",
  "Please try again": "कृपया पुनः प्रयास करें",
  "Connection lost": "कनेक्शन खो गया",
  "Reconnecting...": "पुनः कनेक्ट हो रहा है...",
  "Nothing to clear": "साफ़ करने के लिए कुछ नहीं",
  "All messages cleared": "सभी संदेश साफ़ किए गए",
  "All data cleared": "सभी डेटा साफ़ किया गया",
  "Storage limit reached": "स्टोरेज सीमा पहुंच गई",
  "Some older messages were removed to save space.": "स्थान बचाने के लिए कुछ पुराने संदेश हटा दिए गए हैं।",
  
  // Character count
  "{{remainingChars}} character left": "{{remainingChars}} अक्षर शेष",
  "{{remainingChars}} characters left": "{{remainingChars}} अक्षर शेष",
  
  // Additional keys
  "Font Size": "फ़ॉन्ट आकार",
  "Language changed to {{locale}}": "भाषा {{locale}} में बदली गई",
  "Select language": "भाषा चुनें",
  "Support": "सहायता",
  
  // Brand names (do not translate)
  "Leen": "Leen",
  
  // Message actions
  "Message copied to clipboard": "संदेश क्लिपबोर्ड पर कॉपी किया गया",
  "Read": "पढ़ें",
  "Summarize": "सारांश",
  
  // Ice Breakers Dialog
  "Message Suggestions": "संदेश सुझाव",
  "Select a question to quickly start a conversation about Saudi labor laws.": "सऊदी श्रम कानूनों के बारे में बातचीत जल्दी शुरू करने के लिए एक प्रश्न चुनें।",
  "What are the key employee rights under Saudi labor law? Can you provide a simple overview?": "सऊदी श्रम कानून के तहत कर्मचारी के प्रमुख अधिकार क्या हैं? क्या आप एक सरल अवलोकन प्रदान कर सकते हैं?",
  "What are the employer's obligations regarding work hours, overtime, and leave in Saudi Arabia?": "सऊदी अरब में कार्य घंटे, ओवरटाइम और छुट्टी के संबंध में नियोक्ता की क्या बाध्यताएं हैं?",
  "How does Saudi labor law handle termination of employment and end-of-service benefits?": "सऊदी श्रम कानून रोजगार की समाप्ति और सेवा के अंत के लाभों को कैसे संभालता है?",
  
  // Audio Player Dialog
  "AI Summary": "AI सारांश",
  "Listen to the summarized response using our AI Service.": "हमारी AI सेवा का उपयोग करके सारांश वाले उत्तर को सुनें।",
  "Generating summary...": "सारांश बना रहा है...",
  "Preparing audio...": "ऑडियो तैयार कर रहा है...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "टेक्स्ट प्रोसेस करने में विफल। कृपया पुनः प्रयास करें।",
  "Failed to auto-play audio. Click play to try again.": "ऑडियो ऑटो-प्ले करने में विफल। पुन: प्रयास करने के लिए प्ले पर क्लिक करें।",
  "Failed to load audio. Please try again.": "ऑडियो लोड करने में विफल। कृपया पुनः प्रयास करें।",
  "Audio playback was aborted.": "ऑडियो प्लेबैक रोक दिया गया।",
  "Network error occurred while loading audio.": "ऑडियो लोड करते समय नेटवर्क त्रुटि हुई।",
  "Audio decoding failed.": "ऑडियो डिकोडिंग विफल।",
  "Audio format not supported.": "ऑडियो प्रारूप समर्थित नहीं है।",
  "Failed to setup audio playback": "ऑडियो प्लेबैक सेटअप करने में विफल",
  "Failed to generate speech": "भाषण उत्पन्न करने में विफल",
  "Failed to generate audio. Please try again.": "ऑडियो उत्पन्न करने में विफल। कृपया पुनः प्रयास करें।",
  "Failed to play audio. Please try again.": "ऑडियो चलाने में विफल। कृपया पुनः प्रयास करें।",
  
  // Update Notifications
  "update.updateAvailable": "अपडेट उपलब्ध है",
  "update.newVersionAvailable": "नया संस्करण {{version}} उपलब्ध है",
  "update.refreshToApply": "नवीनतम सुविधाओं और सुधारों को लागू करने के लिए रिफ्रेश करें",
  "update.later": "बाद में",
  "update.updateNow": "अभी अपडेट करें",
  
  // CSAT Feedback
  "We Value Your Feedback": "हम आपकी प्रतिक्रिया को महत्व देते हैं",
  "Give Feedback": "प्रतिक्रिया दें",
  "How would you rate your experience?": "आप अपने अनुभव को कैसे रेट करेंगे?",
  "Very Dissatisfied": "बहुत असंतुष्ट",
  "Dissatisfied": "असंतुष्ट",
  "Neutral": "तटस्थ",
  "Satisfied": "संतुष्ट",
  "Very Satisfied": "बहुत संतुष्ट",
  "Select a rating": "एक रेटिंग चुनें",
  "Comments or Bug Report": "टिप्पणियां या बग रिपोर्ट",
  "Please share your thoughts or report any issues...": "कृपया अपने विचार साझा करें या किसी भी समस्या की रिपोर्ट करें...",
  "Contact Number": "संपर्क नंबर",
  "Feedback Type": "प्रतिक्रिया प्रकार",
  "Select a feedback type": "एक प्रतिक्रिया प्रकार चुनें",
  "Loading...": "लोड हो रहा है...",
  "No feedback types available": "कोई प्रतिक्रिया प्रकार उपलब्ध नहीं है", 
  "(Optional)": "(वैकल्पिक)",
  "Feedback Submitted": "प्रतिक्रिया जमा की गई",
  "Thank you for your feedback!": "आपकी प्रतिक्रिया के लिए धन्यवाद!",
  "Rating Required": "रेटिंग आवश्यक है",
  "Please select a rating before submitting.": "जमा करने से पहले कृपया एक रेटिंग चुनें।",
  "Submit Feedback": "प्रतिक्रिया जमा करें",
  "Submitting...": "जमा किया जा रहा है...",
  "General": "सामान्य",
  "Bug": "बग",
  "Idea": "विचार",
  
  // Feedback Dashboard
  "Feedback Dashboard": "प्रतिक्रिया डैशबोर्ड",
  "Total Feedbacks": "कुल प्रतिक्रियाएँ",
  "All-time submissions": "सभी समय की प्रस्तुतियाँ",
  "Average Rating": "औसत रेटिंग",
  "Out of 5 stars": "5 सितारों में से",
  "Feedback with Comments": "टिप्पणियों के साथ प्रतिक्रिया",
  "Detailed feedback": "विस्तृत प्रतिक्रिया",
  "Rating Distribution": "रेटिंग वितरण",
  "Breakdown of user satisfaction": "उपयोगकर्ता संतुष्टि का विश्लेषण",
  "Rating Percentage": "रेटिंग प्रतिशत",
  "Proportion of each rating": "प्रत्येक रेटिंग का अनुपात",
  "Responses": "प्रतिक्रियाएँ",
  "All Feedback": "सभी प्रतिक्रियाएँ",
  "Detailed view of user submissions": "उपयोगकर्ता प्रस्तुतियों का विस्तृत दृश्य",
  "ID": "आईडी",
  "Rating": "रेटिंग",
  "Comment": "टिप्पणी",
  "Contact": "संपर्क",
  "Date": "तिथि",
  "Page": "पेज",
  "No feedback data available": "कोई प्रतिक्रिया डेटा उपलब्ध नहीं है",
  "No comment": "कोई टिप्पणी नहीं",
  "Not provided": "प्रदान नहीं किया गया",
  "Not available": "उपलब्ध नहीं है",
  
  // Authentication
  "Login": "लॉगिन",
  "Register": "रजिस्टर",
  "Username": "उपयोगकर्ता नाम",
  "Password": "पासवर्ड",
  "Confirm Password": "पासवर्ड की पुष्टि करें",
  "Email": "ईमेल",
  "Full Name": "पूरा नाम",
  "Don't have an account?": "खाता नहीं है?",
  "Already have an account?": "पहले से ही एक खाता है?",
  "Login to continue": "जारी रखने के लिए लॉगिन करें",
  "Create an account": "एक खाता बनाएं",
  "Passwords must match": "पासवर्ड मेल खाना चाहिए",
  "Invalid email": "अमान्य ईमेल",
  "Required": "आवश्यक",
  "Unauthorized": "अनधिकृत",
  "You don't have permission to access this page.": "आपको इस पृष्ठ तक पहुंचने की अनुमति नहीं है।"
};